var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wa-header-wrapper"},[_c('img-v3',{attrs:{"src":_vm.formItem.icon_url,"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }